// import {FormattedMessage} from "react-intl"
// import React from "react"

export default {
	load() {
		return {
			fields: {
				status: {},
				request_id: {},
				gd_request_id: {},
				expected_voucher_amount: {},
				places: {},
				ico: {
					label: "IČO",
					rules: "required|between:8,8"
				},
				dic: {
					label: "DIČ",
					rules: "required|between:10,10"
				},
				start: {},
				startBy: {},
				icdph: {
					label: "IČ DPH",
					rules: ["required", "regex:/^(?=[aA-zZ0-9]*$)(?:.{1}|.{12})$/"]
				},
				consent: {
					label: "Beriem na vedomie spracúvanie poskytnutých osobných údajov",
					type: "checkbox",
					rules: "required",
					value: false
				},
				companyName: {
					label: "Obchodné meno / žiadateľ",
					rules: "required"
				},
				companyLegalForm: {
					label: "Právna forma",
					rules: "required"
				},
				companyIBAN: {
					label: "IBAN",
					rules: ["required", "regex:/^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$/"],
					value: "SK"
				},
				companySWIFT: {
					label: "SWIFT kód"
				},
				skNace: {
					label: "SK NACE",
					rules: "required"
				},
				companyStreet: {
					label: "Ulica a číslo",
					rules: "required"
				},
				companyCity: {
					label: "Obec",
					rules: "required"
				},
				applicantChipForm: {value: JSON.stringify([{name: ""}])},
				numberOfOwners: {
					label: "Počet vlastníkov",
					rules: "integer|between:0,20"
				},
				contactPersonName: {
					label: "Priezvisko, Meno, Titul pred, Titul za",
					rules: "required"
				},
				ownerType_1: {label: "", value: "legalEntity"},
				ownerName_1: {label: "Meno a priezvisko vlastníka"},
				rpo_search_1: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_1: {label: ""},
				ownershipInterest_1: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_2: {label: "", value: "legalEntity"},
				ownerName_2: {label: "Meno a priezvisko vlastníka"},
				rpo_search_2: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_2: {label: ""},
				ownershipInterest_2: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_3: {label: "", value: "legalEntity"},
				ownerName_3: {label: "Meno a priezvisko vlastníka"},
				rpo_search_3: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_3: {label: ""},
				ownershipInterest_3: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_4: {label: "", value: "legalEntity"},
				ownerName_4: {label: "Meno a priezvisko vlastníka"},
				rpo_search_4: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_4: {label: ""},
				ownershipInterest_4: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_5: {label: "", value: "legalEntity"},
				ownerName_5: {label: "Meno a priezvisko vlastníka"},
				rpo_search_5: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_5: {label: ""},
				ownershipInterest_5: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_6: {label: "", value: "legalEntity"},
				ownerName_6: {label: "Meno a priezvisko vlastníka"},
				rpo_search_6: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_6: {label: ""},
				ownershipInterest_6: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_7: {label: "", value: "legalEntity"},
				ownerName_7: {label: "Meno a priezvisko vlastníka"},
				rpo_search_7: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_7: {label: ""},
				ownershipInterest_7: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_8: {label: "", value: "legalEntity"},
				ownerName_8: {label: "Meno a priezvisko vlastníka"},
				rpo_search_8: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_8: {label: ""},
				ownershipInterest_8: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_9: {label: "", value: "legalEntity"},
				ownerName_9: {label: "Meno a priezvisko vlastníka"},
				rpo_search_9: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_9: {label: ""},
				ownershipInterest_9: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_10: {label: "", value: "legalEntity"},
				ownerName_10: {label: "Meno a priezvisko vlastníka"},
				rpo_search_10: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_10: {label: ""},
				ownershipInterest_10: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_11: {label: "", value: "legalEntity"},
				ownerName_11: {label: "Meno a priezvisko vlastníka"},
				rpo_search_11: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_11: {label: ""},
				ownershipInterest_11: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_12: {label: "", value: "legalEntity"},
				ownerName_12: {label: "Meno a priezvisko vlastníka"},
				rpo_search_12: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_12: {label: ""},
				ownershipInterest_12: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_13: {label: "", value: "legalEntity"},
				ownerName_13: {label: "Meno a priezvisko vlastníka"},
				rpo_search_13: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_13: {label: ""},
				ownershipInterest_13: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_14: {label: "", value: "legalEntity"},
				ownerName_14: {label: "Meno a priezvisko vlastníka"},
				rpo_search_14: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_14: {label: ""},
				ownershipInterest_14: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_15: {label: "", value: "legalEntity"},
				ownerName_15: {label: "Meno a priezvisko vlastníka"},
				rpo_search_15: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_15: {label: ""},
				ownershipInterest_15: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_16: {label: "", value: "legalEntity"},
				ownerName_16: {label: "Meno a priezvisko vlastníka"},
				rpo_search_16: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_16: {label: ""},
				ownershipInterest_16: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_17: {label: "", value: "legalEntity"},
				ownerName_17: {label: "Meno a priezvisko vlastníka"},
				rpo_search_17: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_17: {label: ""},
				ownershipInterest_17: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_18: {label: "", value: "legalEntity"},
				ownerName_18: {label: "Meno a priezvisko vlastníka"},
				rpo_search_18: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_18: {label: ""},
				ownershipInterest_18: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_19: {label: "", value: "legalEntity"},
				ownerName_19: {label: "Meno a priezvisko vlastníka"},
				rpo_search_19: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_19: {label: ""},
				ownershipInterest_19: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				ownerType_20: {label: "", value: "legalEntity"},
				ownerName_20: {label: "Meno a priezvisko vlastníka"},
				rpo_search_20: {label: "IČO/Obchodné meno vlastníka"},
				rpo_search_name_20: {label: ""},
				ownershipInterest_20: {label: "Vlastnícky podiel [%]", rules: "numeric|between:5,100"},
				communicationMethod: {
					label: ""
				},
				contactPersonPhone: {
					label: "Telefónne číslo",
					rules: "required",
					placeholder: "+421900111222"
				},
				contactPersonMail: {
					label: "Email",
					rules: "email|required"
				},
				authorizedPersonName: {
					label: "Priezvisko, Meno, Titul pred, Titul za"
				},
				authorizedPersonPhone: {
					label: "Telefónne číslo",
					placeholder: "+421900111222"
				},
				authorizedPersonMail: {
					label: "Email",
					rules: "email"
				},
				region_type_id: {},
				round_id: {
					label: "Zvoľte kolo výzvy",
					rules: "required"
				},
				round_text: {
					label: "Zvoľte kolo výzvy"
				},
				contributionForEnergyAudit: {
					label: "Žiadam o príspevok na vypracovanie energetického auditu",
					type: "checkbox",
					value: false
				},
				dropzone: {},
				companySize: {
					label: "Veľkosť podniku",
					rules: "required"
				}
			}
		}
	}
}

